import _extends from "@babel/runtime/helpers/extends";
import createHttpAction from '../../../utils/createHttpAction';

var _createHttpAction = createHttpAction('CONFIRM_SUBSCRIBER'),
    confirmSubscriberStart = _createHttpAction.confirmSubscriberStart,
    confirmSubscriberSuccess = _createHttpAction.confirmSubscriberSuccess,
    confirmSubscriberFailure = _createHttpAction.confirmSubscriberFailure,
    confirmSubscriberWithOptions = _createHttpAction.confirmSubscriberWithOptions;
/**
 * Confirms a Lucina subscriber.
 *
 * This is the final step of the confirmation flow and should be fired after the user clicks the confirmation button in a confirmation email.
 *
 * ```js
 * // in a component
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * const Test = () => {
 *   const { confirmSubscriber } = subscription.hooks.useSubscriptionActions();
 *   const id = 123;
 *   const token = 'abc123';
 *   const onClick = () => confirmSubscriber(id, token);
 *   return (
 *     <button onClick={onClick}>Confirm!</button>
 *   )
 * }
 *
 * // outside of a react component (eg. a redux thunk)
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * dispatch(subscription.actions.confirmSubscriber(id, token));
 * ```
 *
 * @param {String} id - The id of the subscriber to confirm
 * @param {String} token - The confirmation token for the subscriber
 * @param {Object} [requestConfig] - A valid axios request config to customize the request
 *
 * @returns {Object} - An object that holds the confirmed subscriber data
 */


var confirmSubscriber = function confirmSubscriber(id, token, requestConfig) {
  var _requestConfig;

  if (requestConfig === void 0) {
    requestConfig = {};
  }

  if (!id) {
    throw new Error('confirmSubscriber was called without an `id`. Make sure you pass ' + 'an `id` when calling `confirmSubscriber`: `confirmSubscriber(id, token)`');
  }

  if (!token) {
    throw new Error('confirmSubscriber was called without an `token`. Make sure you pass ' + 'a `token` when calling `confirmSubscriber`: `confirmSubscriber(id, token)`');
  }

  return confirmSubscriberWithOptions(_extends({
    method: 'post',
    url: "https://api-lucina.com/subscribers/" + id + "/confirm/"
  }, requestConfig, {
    data: _extends({}, (_requestConfig = requestConfig) == null ? void 0 : _requestConfig.data, {
      token: token
    })
  }));
};

export { confirmSubscriberStart, confirmSubscriberSuccess, confirmSubscriberFailure, confirmSubscriber };